import React, { useState } from 'react'
import { Box, Button, Typography, CircularProgress } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import Table from './Table'
import DownloadIcon from '@mui/icons-material/Download'
import { useSnackbar } from 'notistack'
import { useExportLuckyDrawTicket } from '../../api/lucky-draw'
import CompanyForm from './company/Form'

const LuckyDraw = () => {
  const [openCreateLuckyDraw, setOpenCreateLuckyDraw] = useState(false)
  const [openCreateCompany, setOpenCreateCompany] = useState(false)

  const { enqueueSnackbar } = useSnackbar()

  const exportApi = useExportLuckyDrawTicket()

  const handleExport = async () => {
    const res = await exportApi
      .mutateAsync()
      .catch(() => enqueueSnackbar('Failed to export data', { variant: 'error' }))
    const url = URL.createObjectURL(res.data)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `Lucky Draw.xlsx`)
    document.body.appendChild(link)
    link.click()
    if (res?.status === 200) enqueueSnackbar(`Exported`, { variant: 'success' })

    return res
  }

  return (
    <Box>
      <Box mb={3} display='flex' justifyContent='center'>
        <Typography variant='h2' style={{ fontSize: '22px' }}>
          Central Networking Night
        </Typography>
      </Box>
      <Box display='flex' flexDirection='column' alignItems='flex-end' gap={1}>
        <Button
          startIcon={<AddIcon />}
          variant='outlined'
          onClick={() => setOpenCreateLuckyDraw(true)}
        >
          Create Lucky Draw
        </Button>
        <Button
          startIcon={<AddIcon />}
          variant='outlined'
          onClick={() => setOpenCreateCompany(true)}
        >
          Create Company
        </Button>
        <Button
          startIcon={<DownloadIcon />}
          endIcon={exportApi.isLoading && <CircularProgress size='1.5rem' />}
          onClick={handleExport}
          disabled={exportApi.isLoading}
        >
          Export Data
        </Button>
      </Box>
      <Table open={openCreateLuckyDraw} setOpen={setOpenCreateLuckyDraw} />
      <CompanyForm open={openCreateCompany} setOpen={setOpenCreateCompany} />
    </Box>
  )
}

export default LuckyDraw
